import { Component } from 'react';
import PropTypes from 'prop-types';
import LoadingIndicator from './LoadingIndicator.com.svg';

class ClientRender extends Component {
  static propTypes = {
    children: PropTypes.func,
    renderLoader: PropTypes.func,
  };

  static defaultProps = {
    children: () => null,
    renderLoader: ({ isMounted }) => (isMounted ? null : <LoadingIndicator />),
  };

  state = { isMounted: false };

  componentDidMount() {
    this.setState({ isMounted: true });
  }

  render() {
    const { children, renderLoader } = this.props;
    const { isMounted } = this.state;
    const loaderNode = renderLoader({ isMounted });

    return loaderNode || children({ isMounted });
  }
}

ClientRender.LoadingIndicator = LoadingIndicator;

export default ClientRender;
